import React, { useState, useContext } from 'react';

import BnplModal from './BnplModal';
import BnplTerms from './BnplTerms';

import Consent from '../../assets/images/consent.svg';

/** context */
import { UserContext } from '../../context/UserContext';
import { formatUSDCurrency } from '../../helpers/format';

/** service */
import { getApplication, updateApplication, validateProperty } from '../../service/api';

export default function OrderSummary({ className, gotoNextStep }) {
  const { profile, appData, updateAppData, setLoading } = useContext(UserContext);
  const purchaseDetailsFeature = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'PurchaseDetailsProperty'
  );
  const [openModal, setOpenModal] = useState(false);
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [error, setError] = useState('');

  const toggleConsent = () => {
    setConsentAccepted(!consentAccepted);
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const consentFeature = appData?.applicationFeatures.find(
        (feature) => feature.name === 'consent'
      );

      const updatedData = await updateApplication([
        {
          itemType: consentFeature.itemType,
          dataType: consentFeature.dataType,
          name: consentFeature.name,
          value: [
            {
              userId: profile.id,
              consented: true,
            },
          ],
        },
      ]);

      if (updatedData.data) {
        updateAppData(updatedData.data);
      }

      const validationData = await validateProperty(consentFeature.name);

      if (validationData.data && validationData.data.errors) {
        if (validationData.data.errors.length) {
          validationData.data.errors.map((error) => {
            const attributes = error.property.split('.');
          });
          return false;
        }
      }

      // full validation

      const res = await validateProperty();

      if (res.data && res.data.errors) {
        console.log(res);
        setTimeout(async () => {
          try {
            const res1 = await getApplication();
            if (res1 && res1.data) {
              updateAppData(res1.data);
            }
          } catch (error) {
            console.log('err', error);
          }
          setLoading(false);
        }, 10000);
      } else {
        setLoading(false);
        // sth went wrong
      }
    } catch (error) {
      console.log(error);
      const errors = error.response.data.errors;
      if (errors.length) {
        setError(errors[0].message);
      }
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <BnplModal openModal={openModal} closeModal={() => setOpenModal(false)}>
        <BnplTerms className="bnpl-form" />
      </BnplModal>
      <div className={className}>
        <div className={`${className}__title`}>
          <h1>Order Summary</h1>
        </div>
        <div className={`${className}__divider`} />
        <div className={`${className}__order-items`}>
          {purchaseDetailsFeature.value?.items.map((item, index) => (
            <div
              className={`${className}__order-items__item`}
              key={`${className}__order-items__item-${index}`}
            >
              <div className={`${className}__order-items__item-key`}>
                <span className="bullet">&#8226;</span>
                {item.itemName}
              </div>
              <div className={`${className}__order-items__item-value`}>
                {formatUSDCurrency(item.salesPrice)}
              </div>
            </div>
          ))}
        </div>
        <div className={`${className}__divider`} />
        <div className={`${className}__summary`}>
          <div className={`${className}__summary-fee`}>
            <div className={`${className}__summary-fee__label`}>Fee</div>
            <div className={`${className}__summary-fee__sum`}>
              {formatUSDCurrency(purchaseDetailsFeature.value?.purchaseAmountBreakdown?.tax)}
            </div>
          </div>
          <div className={`${className}__summary-total`}>
            <div className={`${className}__summary-total__label`}>Total</div>
            <div className={`${className}__summary-total__sum`}>
              {formatUSDCurrency(purchaseDetailsFeature.value?.purchaseAmountBreakdown?.netTotal)}
            </div>
          </div>
        </div>
        <div className={`${className}__divider`} />
        <div className={`${className}__consent`}>
          <div className={`${className}__consent-icon`} onClick={toggleConsent}>
            {consentAccepted ? (
              <img src={Consent} alt="consent" />
            ) : (
              <div className={`${className}__consent-icon-not-accepted`} />
            )}
          </div>
          <div className={`${className}__consent-text`}>
            <div className={`${className}__consent-text-simple`}>
              I have reviewed and agree to the{' '}
            </div>
            <a
              className={`${className}__consent-text-link`}
              href="https://lendistryinteractive.com/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>{' '}
            and{' '}
            <a
              className={`${className}__consent-text-link`}
              href="https://lendistryinteractive.com/privacypolicy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
        <div className={`${className}__button-container`}>
          <button onClick={handleSubmit} disabled={!consentAccepted}>
            Agree & Apply
          </button>
        </div>
      </div>
    </>
  );
}
